// Taşeron portalı — Belge Analizi gelen kutusu: sol ray (plan S25 C3/C3b, `docs/plans/
// S25-analysis-inbox.md`; tasarım incelemesi `docs/reviews/S25-inbox-design.md` §2.3/§5/§6.2).
//
// **Markup (D12).** İç içe `<ul>` + `<button>`, `role="tree"` DEĞİL. 1. seviye artık bir açılır
// panel (S25 kenar çubuğu hiyerarşisi §4): `<h2>` + `aria-expanded`/`aria-controls` taşıyan bir
// `<button>`; `⋯` menüsü bu düğmenin İÇİNDE değil, YANINDA bir KARDEŞ (buton içinde buton
// geçersiz HTML, tarayıcı onu yeniden ebeveynler). 2. seviye (kişi/firma) hâlâ düz bir başlık,
// yalnız 3. seviye (belge) seçilebilir. Açılır panel eklemek `role="tree"`'nin SÖZLEŞMESİNİ
// almaz — roving tabindex, Arrow tuşları, Home/End, type-ahead, `aria-level`, `aria-setsize`,
// `aria-posinset` hâlâ hepsi YOK, hâlâ bilinçli olarak (yarım uygulanmış bir tree rolü ekran
// okuyucu için düz listeden daha KÖTÜdür).
//
// **Seçim vurgusu (D4).** `bg-surface-muted` + `text-fg` — kenar çubuğunun `bg-primary/10
// text-primary`'si KOPYALANMAZ (açık temada 2.43:1, AA'yı geçmez).
//
// **Durum (AC3).** Onaylandı → yeşil ✓ (+ sr-only). Reddedildi → `line-through` + sr-only
// `analysis.item.rejected` (D5 — üstü çizili hiçbir ekran okuyucu tarafından SESLENDİRİLMEZ) +
// ayrı bir `<button>` "Geri al" (satır düğmesinin İÇİNE değil, YANINA — buton içinde buton
// geçersiz HTML).
//
// **BİLİNÇLİ SAHİP GEÇERSİZ KILMASI, 2026-08-11 (`web-ui-designer` "tek renk, üç şekil" spesi).**
// Aşağıdaki cümle AC3'ün ilk sürümüyle ÇELİŞİR — bu bir SAPMA DEĞİL, kayıtlı bir değişikliktir,
// biri "eski davranışı geri getirmesin". Yeni değişmez: gutter artık HER durum için bir glif
// taşır — Onaylandı → `text-success` ✓ `Check` (değişmedi), Reddedildi → `text-muted` ✕ `X`
// (sr-only başlık sütununda KALIR, yukarıdaki `analysis.item.rejected`, İKİNCİ bir sr-only
// EKLEMEZ — ikisi birden "Reddedildi"yi ÇİFT seslendirirdi), Bekliyor → `text-muted` ○ `Circle`
// + sr-only `analysis.item.status.pending` (yeni anahtar). Hayatta kalan disiplin AYNEN geçerli:
// yalnız Onaylandı RENKLİ; Bekliyor ve Reddedildi RENK değil ŞEKİLLE ayrışır, bu yüzden gutter
// sessiz bir kenar boşluğu olarak KALIR ve reddedilmiş bir glif kendi geri planlanmış
// (`text-muted line-through`) satırını asla BASTIRMAZ. Renkli nokta / turuncu sol şerit YASAĞI
// HÂLÂ GEÇERLİ (turuncu tek birincil eylem için ayrılmış kalır) — geçersiz kılma yalnız "Bekliyor
// hiçbir şey göstermez" cümlesini çeviriyor. Eski kural NEDEN vardı: Bekliyor "sessiz varsayılan"
// olarak tasarlanmıştı (o an tek glif Onaylandı'ydı, ayrışma renkle çözülüyordu); üç durumun
// hepsi glif kazanınca o varsayım GEÇERSİZ kaldı — bir sonraki okuyucu bunu regresyon SANIP geri
// ALMASIN.
//
// **KAYIT DIŞI etiketi (C8/AC7, D9).** 2. seviye yalnız `kind === 'subject'` gruplarda, personel
// listesi (`supplierContractorKeys.personnel`, `AnalysisReviewPane`'İN OKUDUĞU AYNI sorgu
// anahtarı — TanStack Query tekilleştirir, ikinci bir ağ isteği DEMEK DEĞİLDİR) yüklendiğinde ve
// `lib/personMatch.ts`'in eşleştirmesi (`extractedIdentity(group.subject, group.items)`, TC-önce/
// ad-yedek) kayıtlı bulamadığında görünür. `Badge tone="neutral"` seçili satırla AYNI dolguyu
// (`bg-surface-muted`) paylaştığı için `border border-border` ŞART (D9) — sınır olmadan seçili
// satırda etiket görünmez olur.
//
// Rayın kendisi bu sayfadaki TEK kaydırma konteynerıdır (bkz. sayfa dosyasındaki `sticky` +
// `max-h` notu). 1. seviye bandı bu `overflow-y-auto`'nun İÇİNDE `position: sticky` (S25 kenar
// çubuğu hiyerarşisi §4.3). **ARŞİV bölümü de artık kaydırmanın İÇİNDE, ağacın SON `<li>`si**
// (Rev. 3 §15) — eski `Arşivlenmiş analizleri yükle` footer'ı (kaydırmanın DIŞINDA) SİLİNDİ:
// dışarıdaki bir kontrol yalnız bir getirme BAŞLATABİLİYORDU, sonucu AYNI kaydırmanın en
// ALTINDA render ediyordu (§11.3) — kullanıcı zaten o kaydırmayı yapmak ZORUNDAYDI, footer
// yalnız görmediği bir isteği başlatma HAKKI satıyordu. Arşiv bandı HİÇBİR pozisyonlama almaz
// (§15.5), bu yüzden aşağıdaki §4.4 kuralı — 1. seviye bandı analiz `<li>`si İÇİNDE TEK
// konumlandırılmış öğe — DOKUNULMAMIŞ kalır. Aradaki `<ul>`/`<li>`'ye ASLA `overflow` eklenmez:
// sticky en yakın kaydırma atasına göre çözülür, araya giren herhangi bir `overflow` yapışmayı
// SESSİZCE (hatasız, testsiz) öldürür.
// **Regresyon koruması, sıradan bir not DEĞİL:** analiz `<li>`si İÇİNDE 1. seviye bandı TEK
// konumlandırılmış öğe KALMALI. Rev. 1 2. seviye başlığını da `sticky top-9` yapmıştı — bir
// grup `<li>`si kaydırmayla dışarı çıktığında kendi containing block'u bandın 0–36 px bölgesinden
// İÇİNDEN geçerek yukarı itiyordu, ikisi AYNI katmanda (`z: 0`) ve DOM'da SONRA gelen grup
// başlığı bandın ÜSTÜNE boyanıyordu — chevron + `⋯` görünmez/tıklanmaz, `web-qa-engineer`
// tarayıcıda yakaladı. Panelin İÇİNE `relative`/`sticky`/herhangi bir `z-` utility EKLEMEK bu
// hatayı YENİDEN AÇAR — tam hesap ve reddedilen iki alternatif için S25 kenar çubuğu hiyerarşisi
// §4.4'e bakın.
//
// **Bandın dolgusu hiyerarşiyi AYIRMAZ (S25 kenar çubuğu hiyerarşisi §2).** 1. seviye bandının
// `bg-bg`'si 2. seviyenin `bg-surface`'ine karşı yalnız 1.22:1 (açık) / 1.12:1 (koyu) — bu bir
// TENTE, kontrast değil. Seviyeleri gerçekten ayıran `border-border-strong` KURALIDIR (3.79:1 /
// 3.40:1 `bg-surface` üzerinde) — bu token rayın BAŞKA HİÇBİR yerinde kullanılmaz, yani güçlü
// bir kural "analiz sınırı" DEMEKTİR ve başka bir şey değil. Dolgunun tek işi bandın satır gibi
// OKUNMASINI engellemek. Biri bandı bir hex'e uzanarak "düzeltmeye" kalkışmasın diye burada.
//
// **`runningAnalyses` (S25 web kod incelemesi #1).** Uçuştaki (`Queued`/`Running`) analizler —
// listenin EN ÜSTÜNDE, aranabilir/seçilebilir ağacın DIŞINDA sabit bir bölüm (spinner + "Analiz
// kuyrukta"/"Analiz sürüyor", tray'in AYNI etiketleri — `analysis.tray.queued`/`running`). Satır
// bir `<button>` DEĞİLDİR (incelemek için henüz hiçbir kalem yok, `items` boş — §20) — `⋯` menü
// de TAŞIMAZ (kapsam: yalnız durum bilgisi; arşivleme/silme rayın normal analiz satırlarının işi
// kalır). Sayfa dosyası bir analiz terminal olunca bunu `awaiting-review`/`archived`e devretmek
// için KENDİ geçiş efektini çalıştırır — bu bileşen yalnız SUNULAN listeyi render eder. Uçuşta
// bir analiz olması BEKLEYEN bölümünün kendi boş satırını artık SUSTURMAZ (Rev. 3 §14.3) — hiç
// bekleyen belge yokken bile "⟳ Analiz sürüyor" ile "Bekleyen analiz yok." AYNI ANDA görünür,
// ikisi de doğru, farklı sorulara cevap verir.
//
// **`truncatedNotice` (S25 web kod incelemesi #5).** `awaiting-review` sunucu sayfalamasıyla
// (§3) sınırlıdır (`DocumentAnalysisInboxPage.tsx`, `AWAITING_REVIEW_PAGE_SIZE`) — doldurulursa
// aramanın ÜSTÜNDE, sabit bir bantta dürüst bir "yalnız en yeni N/M gösteriliyor" uyarısı
// render edilir (rayın kendi kaydırmasının dışında, kaçırılamaz). AYNI `filteredTotal >
// items.length` koşulu, Belgeler sayfasındaki `AnalysisInboxButton` rozetinin `8` yerine `8+`
// göstermesini de tetikler (Rev. 3 §13.3) — iki yüzey sayfalama konusunda AYNI gerçeği söyler.
//
// **Bölüm-bazlı durum satırları (Rev. 3 §14).** Her bölüm KENDİ durumuna cevap verir ve bu
// asla bir KARDEŞ bölümün durumuyla bastırılmaz/değiştirilmez — arşivin yüklenmiş olması
// BEKLEYEN bölümünün "Bekleyen analiz yok." demesini SUSTURAMAZ (owner raporu). Eski
// `hasAnyRow` boolean'ı SİLİNDİ: üç ayrı soruyu (uçuştaki + bekleyen + arşiv) TEK booleanda
// ORluyordu, bu yüzden bir kardeşin durumu diğerinin mesajını yutuyordu ve kendi süzgeç kuralı
// `renderAnalysisNode`'un gizleme kuralından bağımsızca SAPMIŞTI. Yerine TEK bir yüzey-görünürlük
// yüklemi geldi, `isNodeVisible` — `renderAnalysisNode`'un erken `return null`ının TAM
// NEGASYONU, böylece ikisi asla BİRBİRİNDEN SAPAMAZ; hem satırlar hem durum satırları AYNI
// yüklemi okur.

import {
  ApiError,
  Button,
  type DocumentAnalysisDetailDto,
  type DocumentAnalysisDto,
  type DocumentAnalysisItemDto,
  Input,
  NETWORK_ERROR_CODE,
  Spinner,
  Tag,
  cn,
  documentAnalysesApi,
  isApiError,
  resolveApiErrorMessage,
  supplierContractorApi,
  useDocumentTypes,
} from '@isgportal/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { TFunction } from 'i18next';
import {
  Archive,
  Building2,
  Check,
  ChevronRight,
  Circle,
  CircleHelp,
  Info,
  TriangleAlert,
  Undo2,
  User,
  X,
} from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  type AnalysisGroup,
  type DocumentTypeLabelFn,
  analysisGroupLabel,
  analysisItemLabel,
  groupAnalysisItems,
  itemStatus,
} from '../lib/analysisInboxTree';
import { formatPageSpan } from '../lib/documentAnalysisPages';
import { formatShortDateTime } from '../lib/format';
import { extractedIdentity, personnelRegistrationStatus } from '../lib/personMatch';
import { supplierContractorKeys } from '../lib/supplierContractorKeys';
import { AnalysisInboxMenu } from './AnalysisInboxMenu';

export interface AnalysisInboxRailEntry {
  analysis: DocumentAnalysisDto;
  detail: DocumentAnalysisDetailDto | undefined;
}

export interface AnalysisInboxRailProps {
  className?: string;
  companyId: number | null;
  culture: string;
  /** `?status=awaiting-review` — varsayılan liste, HER ZAMAN yüklü. */
  analyses: AnalysisInboxRailEntry[];
  /** `?status=archived` — yalnız `archivedRequested` iken dolu (AC18: varsayılan listede YOK). */
  archivedAnalyses: AnalysisInboxRailEntry[];
  selectedItemUuid: string | null;
  /** Seçili kalemin ait olduğu analiz — S25 kenar çubuğu hiyerarşisi §5.4'ün otomatik-açma
   * kuralı için. Sayfa bunu zaten kendi state'inde tutuyor; rayın her `detail`i tarayıp sahibini
   * bulması yerine sayfadan geçirmek daha ucuz ve daha dürüst. */
  selectedAnalysisUuid: string | null;
  onSelectItem: (analysisUuid: string, itemUuid: string) => void;
  archivedRequested: boolean;
  archivedLoading: boolean;
  archivedError: ApiError | null;
  onRequestArchived: () => void;
  /** Arşiv çekimi başarısız olduktan sonra "Tekrar dene" — Rev. 3 §15.4. Eski akışta bu hata
   * TERMİNALDİ (sayfa yenilemesi dışında kurtarma yolu yoktu); artık panel içindeki bir ghost
   * `<Button>` bunu doğrudan çağırır. */
  onRetryArchived: () => void;
  /** `?status=active` (`Queued`/`Running`) — dosya üstü not. Boşsa bölüm hiç render edilmez. */
  runningAnalyses: DocumentAnalysisDto[];
  /** `awaiting-review` sunucu sayfalamasıyla kesildiyse (dosya üstü not, #5) — `null` = kesilme
   * yok, uyarı gösterilmez. */
  truncatedNotice: { shown: number; total: number } | null;
}

interface VisibleGroup {
  group: AnalysisGroup;
  label: string;
  items: DocumentAnalysisItemDto[];
}

function visibleGroups(
  detail: DocumentAnalysisDetailDto,
  query: string,
  t: TFunction,
  typeLabel: DocumentTypeLabelFn,
): VisibleGroup[] {
  return groupAnalysisItems(detail)
    .map((group) => {
      const label = analysisGroupLabel(group, t);
      const items = query
        ? group.items.filter((item) => {
            // Satırla ve inceleme panelinin `h2`'siyle AYNI metin (`analysisItemLabel`).
            const title = analysisItemLabel(item, t, typeLabel).toLowerCase();
            return title.includes(query) || label.toLowerCase().includes(query);
          })
        : group.items;
      return { group, label, items };
    })
    .filter((g) => g.items.length > 0);
}

function itemSecondary(
  item: DocumentAnalysisItemDto,
  detail: DocumentAnalysisDetailDto,
  t: TFunction,
): string | null {
  const source = item.sourceDocumentUuid
    ? detail.sources.find((s) => s.documentUuid === item.sourceDocumentUuid)
    : undefined;
  const span = formatPageSpan(item.pages);
  if (source && span) {
    return t('analysis.inbox.itemPageSpan', { fileName: source.fileName, span });
  }
  if (source) {
    return source.fileName;
  }
  if (span) {
    return t('analysis.result.pages', { span });
  }
  return null;
}

export function AnalysisInboxRail({
  className,
  companyId,
  culture,
  analyses,
  archivedAnalyses,
  selectedItemUuid,
  selectedAnalysisUuid,
  onSelectItem,
  archivedRequested,
  archivedLoading,
  archivedError,
  onRequestArchived,
  onRetryArchived,
  runningAnalyses,
  truncatedNotice,
}: AnalysisInboxRailProps) {
  const { t } = useTranslation();
  const { label: typeLabel } = useDocumentTypes();
  const queryClient = useQueryClient();
  const [query, setQuery] = useState('');
  const trimmedQuery = query.trim().toLowerCase();

  // S25 kenar çubuğu hiyerarşisi §5.1 — 1. seviye açılır panellerin durumu. `expandOverrides`
  // yalnız KULLANICININ kendi çevirdiği analizleri tutar (uuid → açık/kapalı); dokunulmamış her
  // analiz `isExpanded`'ın varsayılanına düşer (§5.2: bekleyen listede AÇIK, arşivde KAPALI —
  // arşivdeki her analizin sıfır bekleyen kalemi vardır, plan A5'in etkin-arşiv yüklemi gereği).
  // Oturum içi state — URL'de DEĞİL (paylaşılan bağlantı başkasının katlama kararını taşımasın)
  // ve `localStorage`'da DEĞİL (§5.3) — sayfa yeniden yüklendiğinde kaybolması ZARARSIZDIR çünkü
  // varsayılan zaten "açık": bir yeniden yükleme yalnız iş GÖSTEREBİLİR, asla GİZLEYEMEZ.
  const [expandOverrides, setExpandOverrides] = useState<ReadonlyMap<string, boolean>>(
    () => new Map(),
  );

  function toggleAnalysis(uuid: string, next: boolean) {
    setExpandOverrides((prev) => new Map(prev).set(uuid, next));
  }

  function isExpanded(uuid: string, isArchivedSection: boolean): boolean {
    const override = expandOverrides.get(uuid);
    if (override !== undefined) return override; // kullanıcının kendi kararı kazanır
    if (trimmedQuery.length > 0) return true; // arama kendi eşleşmelerini asla gizleyemez
    return !isArchivedSection; // varsayılan: bekleyen açık, arşiv kapalı
  }

  // §5.4 — seçim RAYIN DIŞINDAN değiştiğinde (bir `/document-analysis/:uuid` derin bağlantısı
  // mount'ta, ya da `handleDecided`'ın otomatik-ilerlemesi (AC16) başka bir analize geçtiğinde)
  // seçili kalemi taşıyan analiz OTOMATİK açılır. Render AŞAMASINDA state ayarlamak — React'ın
  // belgelenen "prop değiştiğinde state'i ayarlama" deyimi, sayfanın kendi `appliedRouteUuidRef`
  // deyimiyle AYNI — bir `useEffect` DEĞİL: commit'ten ÖNCE yeniden render eder, seçili satır
  // hiçbir zaman bir kare boyunca "eksik" boyanmaz. KALEME göre anahtarlanır, ANALİZE göre
  // DEĞİL — böylece kullanıcı bir analizi kapattıktan SONRA aynı analiz içinde ikinci bir kaleme
  // otomatik-ilerlemek o analizi yeniden açar (analize göre anahtarlamak bu seçimi görünmez
  // bırakırdı). Override'ı EZMEZ, yalnız AYARLAR — `expanded = holdsSelection || override`
  // biçimindeki bir kural, seçimi taşıyan bir analizi kullanıcının kapatma tıklamasını
  // İŞLEVSİZ bırakırdı; bu, önlediği şeyden DAHA KÖTÜ olurdu.
  const [appliedSelectionItemUuid, setAppliedSelectionItemUuid] = useState<string | null>(null);
  if (selectedItemUuid !== null && selectedItemUuid !== appliedSelectionItemUuid) {
    setAppliedSelectionItemUuid(selectedItemUuid);
    if (selectedAnalysisUuid !== null) {
      setExpandOverrides((prev) =>
        prev.get(selectedAnalysisUuid) === true
          ? prev
          : new Map(prev).set(selectedAnalysisUuid, true),
      );
    }
  }

  // KAYIT DIŞI etiketi için — `AnalysisReviewPane`'in Kişi seçicisini besleyen SORGUYLA aynı
  // anahtar (`supplierContractorKeys.personnel`), TanStack Query tekilleştirir.
  const personnelQuery = useQuery({
    queryKey: supplierContractorKeys.personnel(companyId),
    queryFn: () => supplierContractorApi.listSupplierContractorPersonnel(),
    enabled: companyId != null,
  });

  const [restoringItemUuids, setRestoringItemUuids] = useState<Set<string>>(new Set());
  const [restoreErrors, setRestoreErrors] = useState<Map<string, ApiError>>(new Map());

  const restoreMutation = useMutation<
    Awaited<ReturnType<typeof documentAnalysesApi.restoreDocumentAnalysisItem>>,
    ApiError,
    { analysisUuid: string; itemUuid: string }
  >({
    mutationFn: ({ analysisUuid, itemUuid }) =>
      documentAnalysesApi.restoreDocumentAnalysisItem(analysisUuid, itemUuid),
  });

  // F3 (S25 web güvenlik incelemesi) — `restoreMutation` bu bileşenin TÜM reddedilmiş
  // satırlarınca PAYLAŞILAN tek `useMutation`. Kurulu query-core 5.101.4'te `mutate(vars,
  // { onSuccess, onError, onSettled })` bu paylaşılan gözlemcinin TEK `#mutateOptions`
  // alanına yazar; eşzamanlı bir ikinci `mutate()` çağrısı (başka bir satırda "Geri al")
  // ilkinin callback'lerini SESSİZCE EZER — A satırı sonsuza kadar döner, invalidasyonu hiç
  // çalışmaz, hata gösterilmez. Çözüm: `mutateAsync`'i İKİNCİ argüman (callback'ler) OLMADAN
  // doğrudan çağırıp DÖNEN promise'i (her çağrı için AYRI bir `Mutation` nesnesine bağlı,
  // paylaşılan `#mutateOptions`'tan bağımsız) satır başına `try/catch/finally` ile okumak —
  // eşzamanlı satırlar birbirinin sonucunu artık EZEMEZ.
  async function restoreItem(analysisUuid: string, itemUuid: string) {
    setRestoringItemUuids((prev) => new Set(prev).add(itemUuid));
    setRestoreErrors((prev) => {
      if (!prev.has(itemUuid)) {
        return prev;
      }
      const next = new Map(prev);
      next.delete(itemUuid);
      return next;
    });
    try {
      await restoreMutation.mutateAsync({ analysisUuid, itemUuid });
      for (const filter of ['awaiting-review', 'active', 'all', 'archived'] as const) {
        queryClient.invalidateQueries({
          queryKey: supplierContractorKeys.analyses(companyId, filter),
        });
      }
      queryClient.invalidateQueries({
        queryKey: supplierContractorKeys.analysis(companyId, analysisUuid),
      });
    } catch (error) {
      const apiError = isApiError(error)
        ? error
        : new ApiError({
            statusCode: 0,
            errorCode: NETWORK_ERROR_CODE,
            message: NETWORK_ERROR_CODE,
          });
      setRestoreErrors((prev) => new Map(prev).set(itemUuid, apiError));
    } finally {
      setRestoringItemUuids((prev) => {
        const next = new Set(prev);
        next.delete(itemUuid);
        return next;
      });
    }
  }

  function renderItemRow(
    analysisUuid: string,
    item: DocumentAnalysisItemDto,
    detail: DocumentAnalysisDetailDto,
  ) {
    const status = itemStatus(item);
    const isSelected = selectedItemUuid === item.uuid;
    // Tek etiket kaynağı — inceleme panelinin `h2`'si ve ray araması AYNI metni okur.
    const title = analysisItemLabel(item, t, typeLabel);
    const secondary = itemSecondary(item, detail, t);
    const restoring = restoringItemUuids.has(item.uuid);
    const restoreError = restoreErrors.get(item.uuid);

    return (
      <li key={item.uuid} className="">
        <div className={cn('flex items-stretch gap-1 pr-2 pl-2', isSelected && 'bg-surface-muted')}>
          <button
            type="button"
            aria-current={isSelected ? 'true' : undefined}
            onClick={() => onSelectItem(analysisUuid, item.uuid)}
            className="flex min-w-0 flex-1 items-start gap-1.5 py-2 pl-3 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
          >
            {/* Durum gutter'ı — sabit genişlik, HER satırda mevcut (boş kalsa bile) böylece
                başlık x'i satırdan satıra KAYMAZ. `h-5` `text-sm`'in satır yüksekliğiyle
                eşleşir (20px) — glif başlığın İKİ satırlık yığının ortasına değil, yalnız İLK
                satırının cap-height'ına hizalanır (owner ekran görüntüsü). */}
            <span className="flex h-5 w-4 shrink-0 items-center justify-center">
              {status === 'accepted' ? (
                <>
                  <Check className="h-4 w-4 shrink-0 text-success" aria-hidden="true" />
                  <span className="sr-only">{t('analysis.item.status.accepted')}</span>
                </>
              ) : status === 'rejected' ? (
                <X className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" />
              ) : (
                <>
                  <Circle className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" />
                  <span className="sr-only">{t('analysis.item.status.pending')}</span>
                </>
              )}
            </span>
            <span className="flex min-w-0 flex-1 flex-col gap-0.5">
              {/* İşleyiş bulgusu göstergesi (§20 `DocumentAnalysisItemDto.issues`) — başlığın
                  YANINDA, renk YOK (yalnız `text-muted`), rozet/tooltip YOK: bu satırın kendisi
                  zaten bir `<button>`, içine ikinci bir odaklanabilir öğe (Tooltip'in kendi
                  butonu) geçersiz iç içe buton üretirdi (`restoreItem` düğmesinin bu satırın
                  KARDEŞİ olmasıyla AYNI gerekçe). Reddedilmiş satırda BASTIRILIR — reddedilmiş
                  bir kalemin bulguları artık incelemeciyi ilgilendirmez. */}
              <span className="flex min-w-0 flex-1 items-center gap-1">
                <span
                  className={cn(
                    'min-w-0 truncate text-sm',
                    isSelected ? 'font-medium text-fg' : 'text-fg',
                    status === 'rejected' && 'text-muted line-through',
                  )}
                >
                  {title}
                </span>
                {item.issues.length > 0 && status !== 'rejected' ? (
                  <>
                    <Info className="h-3.5 w-3.5 shrink-0 text-muted" aria-hidden="true" />
                    <span className="sr-only">{t('analysis.inbox.itemHasIssue')}</span>
                  </>
                ) : null}
              </span>
              {status === 'rejected' ? (
                <span className="sr-only">{t('analysis.item.rejected')}</span>
              ) : null}
              {secondary ? <span className="truncate text-xs text-muted">{secondary}</span> : null}
            </span>
          </button>
          {status === 'rejected' ? (
            <button
              type="button"
              disabled={restoring}
              aria-label={t('analysis.item.restoreAria', { title })}
              onClick={() => restoreItem(analysisUuid, item.uuid)}
              className="shrink-0 self-center p-1 text-muted hover:bg-surface-muted hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-60"
            >
              {restoring ? (
                <Spinner className="h-4 w-4" />
              ) : (
                <Undo2 className="h-4 w-4" aria-hidden="true" />
              )}
            </button>
          ) : null}
        </div>
        {restoreError ? (
          <p className="pb-1 pl-3 pr-3 text-xs text-danger">
            {t(restoreError.errorCode, {
              defaultValue: t('analysis.item.restoreFailed'),
              ...(restoreError.messageData ?? {}),
            })}
          </p>
        ) : null}
      </li>
    );
  }

  // Rev. 3 §14.1 — tek paylaşılan görünürlük yüklemi. `renderAnalysisNode`'un erken
  // `return null`ının TAM NEGASYONU: burada bir kural değişirse `renderAnalysisNode`'un
  // gizleme kuralı da AYNI yerde değişmek zorunda, aksi hâlde ikisi SAPAR (dosya üstü not).
  function isNodeVisible(entry: AnalysisInboxRailEntry): boolean {
    if (trimmedQuery.length === 0) return true; // gizleme kuralı yalnız arama VARKEN çalışır
    if (entry.detail === undefined) return true; // yükleniyor → başlık kalır ("boş" DEMEZ)
    return visibleGroups(entry.detail, trimmedQuery, t, typeLabel).length > 0;
  }

  function renderAnalysisNode(entry: AnalysisInboxRailEntry, isArchivedSection: boolean) {
    const groups = entry.detail ? visibleGroups(entry.detail, trimmedQuery, t, typeLabel) : [];
    // Must-fix #4 (sign-off) — arama HİÇBİR kalemi eşleştirmiyorsa bu analizin `ANALİZ · …`
    // başlığı da gizlenir; aksi hâlde başlık altında hiçbir belge kalmadan görünür kalır ve bu
    // "bu analizde belge yok" gibi okunur (yanlış) — gerçek durum "bu arama sorgusuyla eşleşen
    // yok"tur. Sorgu BOŞKEN (`trimmedQuery.length === 0`) bu kural İŞLEMEZ: kararı zaten
    // verilmiş kalemlerden oluşan bir analiz de kendi başlığını ve ⋯ menüsünü hak eder. Detay
    // hâlâ YÜKLENİYORSA (`entry.detail === undefined`) da başlık kalır — spinner "yükleniyor"
    // der, "boş" demez. Gizleme koşulu yukarıdaki `isNodeVisible`'ın TAM NEGASYONU — ikisi
    // ayrı yazılmaz, burada `!isNodeVisible(entry)` çağrılır.
    //
    // Sorgu BOŞ DEĞİLKEN varsayılan açılma durumu AÇIK'a döner (§5.5, `isExpanded`) — kullanıcının
    // kendi daraltma kararı (`expandOverrides`) yine kazanır. Daraltılmış bir başlık bu durumda
    // FİLTRELENMİŞ eşleşme sayısını gösterir (`visibleItemCount`, aynı `visibleGroups(...)`
    // çağrısından) — bu sayı, aramadan ÖNCE daraltılmış bir analizin eşleşmelerini gizlemesini
    // önleyen şeydir; biri diğeri olmadan gönderilmez.
    if (!isNodeVisible(entry)) {
      return null;
    }
    const expanded = isExpanded(entry.analysis.uuid, isArchivedSection);
    const visibleItemCount = groups.reduce((n, g) => n + g.items.length, 0);
    const panelId = `analysis-panel-${entry.analysis.uuid}`;
    const toggleId = `analysis-toggle-${entry.analysis.uuid}`;
    // Rev. 3 §15.6 — arşivdeki analizler `Arşivlenmiş` bandının (kendisi bir `<h2>`) ALTINDA
    // `<h3>`; bekleyenler sayfanın 2. seviye başlığı olarak `<h2>` kalır. Okuma sırası h1 (sayfa)
    // → h2 (bekleyen) → h2 (`Arşivlenmiş`) → h3 (arşivlenmiş analizler) → h2 (inceleme paneli) —
    // hiçbir seviye ATLANMAZ, axe'in `heading-order`ı sağlanır.
    const Heading = isArchivedSection ? 'h3' : 'h2';
    return (
      <li key={entry.analysis.uuid} className="border-t border-border first:border-t-0">
        <div
          className={cn(
            'sticky top-0 z-[var(--z-base)] flex h-9 items-center gap-1 bg-bg pl-2 pr-2',
            expanded && 'border-b border-border',
          )}
        >
          <Heading className="flex min-w-0 flex-1">
            <button
              type="button"
              id={toggleId}
              aria-expanded={expanded}
              aria-controls={expanded ? panelId : undefined}
              onClick={() => toggleAnalysis(entry.analysis.uuid, !expanded)}
              className="flex min-w-0 flex-1 items-center gap-1.5 px-1 py-1 text-left text-muted hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
            >
              <ChevronRight
                className={cn(
                  'h-3.5 w-3.5 shrink-0 transition-transform duration-150',
                  expanded && 'rotate-90',
                )}
                aria-hidden="true"
              />
              <span className="min-w-0 flex-1 truncate text-xs font-medium">
                {t('analysis.inbox.analysisHeading', {
                  date: formatShortDateTime(entry.analysis.queuedAt, culture),
                })}
              </span>
              {!expanded && entry.detail !== undefined ? (
                <span className="shrink-0 text-xs tnum">
                  {t('analysis.inbox.collapsedCount', { count: visibleItemCount })}
                </span>
              ) : null}
            </button>
          </Heading>

          {/* `⋯` menüsü başlığın (bekleyende `<h2>`, arşivde `<h3>`, §15.6) KARDEŞİ — açılır
              düğmenin İÇİNE değil YANINA: buton içinde buton geçersiz HTML, tarayıcı onu
              yeniden ebeveynler. */}
          <AnalysisInboxMenu
            companyId={companyId}
            analysisUuid={entry.analysis.uuid}
            status={entry.analysis.status}
            detail={entry.detail}
            archived={isArchivedSection}
          />
        </div>

        {expanded ? (
          // `role="group"`, `role="region"` DEĞİL (S25 kenar çubuğu hiyerarşisi §4.2.3) —
          // `region` bir LANDMARK'tır, 200 analiz 200 landmark demektir (WAI tam bu eşiğin
          // (~6 panel) üstünde `region`ı önerMEZ). biome-ignore aşağıda: önerilen `<fieldset>`
          // form KONTROLLERİ için, bu bir form DEĞİL — erişilebilir ad zaten `aria-labelledby`
          // ile `<h2>`'nin `<button>`'ına bağlı, bir `<legend>`e değil.
          // biome-ignore lint/a11y/useSemanticElements: role="group" kasıtlı, <fieldset> yanlış semantik (yukarıdaki not)
          <div id={panelId} role="group" aria-labelledby={toggleId}>
            {entry.detail === undefined ? (
              <div className="flexitems-center gap-2 px-3 py-2 text-sm text-muted">
                <Spinner className="h-4 w-4" />
                {t('common.loading')}
              </div>
            ) : (
              <ul>
                {groups.map(({ group, label, items }) => {
                  const registrationStatus =
                    group.kind === 'subject' && personnelQuery.data !== undefined
                      ? personnelRegistrationStatus(
                          extractedIdentity(group.subject, group.items),
                          personnelQuery.data,
                        )
                      : null;
                  // İsim modelden çıkarılmış metin — TC kimlik belgeleri BÜYÜK HARFLE
                  // transkribe edilir, `MEHMET ÇAĞLAR ÖZTÜRK` veride zaten büyük harfle gelir
                  // (S25 kenar çubuğu hiyerarşisi §0.2). 14 px'lik glif, 352 px genişlikte bu
                  // satırın "bir belge satırı" değil "bir kişi hakkındaki belge grubu" olarak
                  // okunmasını sağlayan şey — `text-muted` + `aria-hidden`, bir DURUM göstergesi
                  // DEĞİLDİR (AC3, her durumun kendi gutter glifini — ✓/✕/○ — yönetir,
                  // buna dokunulmaz — AC3 gerekçesiyle SİLİNMESİN). `CircleHelp`, `HelpCircle`
                  // DEĞİL: lucide-react 0.469 adını değiştirdi, eski ad artık export edilmiyor.
                  const GroupGlyph =
                    group.kind === 'subject'
                      ? User
                      : group.kind === 'company'
                        ? Building2
                        : CircleHelp;
                  const groupLabelId = `analysis-group-${entry.analysis.uuid}-${group.key}`;
                  return (
                    <li key={group.key} className="border-t border-border first:border-t-0">
                      {/* Rev. 2 — BİLEREK sabitlenmemiş (S25 kenar çubuğu hiyerarşisi §4.4).
                          v1 burayı `sticky top-9` yapmıştı: bir grup `<li>`si kaydırmayla
                          DIŞARI çıktığında kendi header'ı 1. seviye bandının 0–36 px bölgesinden
                          İÇİNDEN geçerek yukarı itiliyordu — ikisi de `z: 0`, DOM'da SONRA gelen
                          bu header bandın ÜSTÜNE boyanıyordu (chevron + `⋯` görünmez/tıklanmaz,
                          QA `elementFromPoint` ile doğruladı, HER grup sınırında). Düzeltme akışta
                          bırakmak: analiz `<li>`si İÇİNDE artık TEK konumlandırılmış öğe 1. seviye
                          bandı, bu yüzden CSS boyama sırasına göre HER kaydırma konumunda satırların
                          ÜSTÜNDE kalır — kanıtlanabilir, deneysel değil. Burayı yeniden `sticky`
                          YAPMAYIN (bkz. §3.1'in "bandın TEK konumlandırılmış öğe olması" kuralı). */}
                      <div className="flex items-center gap-1.5 bg-surface py-1.5 pl-6 pr-3">
                        <GroupGlyph
                          className="h-3.5 w-3.5 shrink-0 text-muted"
                          aria-hidden="true"
                        />
                        {/* `font-semibold` (D4'ün seçili satırı `font-medium`) — 2. seviye
                            seçili bir satırdan DAHA SESSİZ okunmasın diye onu geride bırakmalı. */}
                        <span
                          id={groupLabelId}
                          className="min-w-0 truncate text-sm font-semibold text-fg"
                        >
                          {label}
                        </span>
                        {registrationStatus === 'unregistered' ? (
                          <Tag color="gray" className="shrink-0 border border-border">
                            {t('analysis.person.unregistered')}
                          </Tag>
                        ) : registrationStatus === 'invited' ? (
                          // #2 (S25 web kod incelemesi) — davet edilmiş ama henüz etkinleşmemiş bir
                          // kişiyle eşleşme "hiç duyulmamış biri"nden AYRI bir durumdur; `KAYIT DIŞI`
                          // yanlış olurdu (kişi zaten sistemde, yalnız pasif) — kendi rozeti + tonu
                          // (`warning`, davet durumu rozetleriyle AYNI ton, bkz. `personnelStatusTone`).
                          <Tag color="blue" className="shrink-0">
                            {t('analysis.person.invited')}
                          </Tag>
                        ) : null}
                      </div>
                      {/* Girinti kılavuzu — 2. seviye kendi satırlarına bir DOLGUYLA değil bu
                          çizgiyle SAHİP çıkar (S25 kenar çubuğu hiyerarşisi §3.3, VS Code/Notion/
                          Figma katmanları deyimi); `aria-labelledby` bu listeyi kişinin adıyla
                          adlandırır, 2. seviyenin kendi başlık öğesine ihtiyacı KALMAZ (§4.2). */}
                      <ul className="ml-0" aria-labelledby={groupLabelId}>
                        {items.map((item) =>
                          renderItemRow(
                            entry.analysis.uuid,
                            item,
                            entry.detail as DocumentAnalysisDetailDto,
                          ),
                        )}
                      </ul>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>
        ) : null}
      </li>
    );
  }

  // Rev. 3 §15.2 — arşiv artık tek bir açılır panel; band hem etiketi hem satırları taşır.
  const archivedToggleId = 'analysis-archived-toggle';
  const archivedPanelId = 'analysis-archived-panel';
  // Sayfa firma değişiminde `archivedRequested`i sıfırlar; TÜREVİ almak bandı da kendiliğinden
  // kapatır — ayrı bir efekt/temizlik GEREKMEZ.
  const [archivedOpenState, setArchivedOpenState] = useState(false);
  const archivedOpen = archivedOpenState && archivedRequested;
  const archivedVisible = archivedAnalyses.filter(isNodeVisible);

  function toggleArchived() {
    if (!archivedRequested) {
      onRequestArchived(); // İLK tıklama: getir + aç
      setArchivedOpenState(true);
      return;
    }
    setArchivedOpenState((open) => !open); // sonrası: yalnız katla/aç, YENİDEN İSTEK YOK
  }

  return (
    <div className={cn('flex flex-col overflow-hidden bg-surface', className)}>
      <div className="border-b border-border p-3">
        <Input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t('analysis.inbox.searchPlaceholder')}
          aria-label={t('analysis.inbox.searchLabel')}
        />
      </div>

      {/* #5 (S25 web kod incelemesi) — kaydırmanın DIŞINDA, sabit bant: "yalnız en yeni N/M
          gösteriliyor" listenin ALTINA gizlenip GÖZDEN KAÇMASIN. */}
      {truncatedNotice ? (
        <div className="flex items-start gap-2 border-b border-border bg-surface-muted px-3 py-2 text-xs text-muted">
          <TriangleAlert className="mt-0.5 h-3.5 w-3.5 shrink-0 text-fg" aria-hidden="true" />
          <span>
            {t('analysis.inbox.truncated', {
              shown: truncatedNotice.shown,
              total: truncatedNotice.total,
            })}
          </span>
        </div>
      ) : null}

      {/* #1 (S25 web kod incelemesi) — uçuştaki analizler, kaydırmanın DIŞINDA sabit bir bölüm
          (dosya üstü not). Neredeyse HER ZAMAN 0 ya da 1 satırdır (S19-D5 — tek taşeron-başına
          slot). */}
      {runningAnalyses.length > 0 ? (
        <ul className="border-b border-border">
          {runningAnalyses.map((analysis) => (
            <li key={analysis.uuid} className="flex items-center gap-2 px-3 py-2 text-sm text-fg">
              <Spinner className="h-4 w-4 shrink-0" aria-hidden="true" />
              <span aria-live="polite" className="min-w-0 flex-1 truncate">
                {t(
                  analysis.status === 'Running' ? 'analysis.tray.running' : 'analysis.tray.queued',
                )}
                {' · '}
                {formatShortDateTime(analysis.queuedAt, culture)}
              </span>
            </li>
          ))}
        </ul>
      ) : null}

      <nav aria-label={t('analysis.inbox.treeLabel')} className="min-h-0 flex-1 overflow-y-auto">
        <ul>
          {analyses.map((entry) => renderAnalysisNode(entry, false))}

          {/* BEKLEYEN bölümünün KENDİ durum satırı — arşivin yüklenmiş olması bunu SUSTURMAZ
              (Rev. 3 §14, owner raporu: "Do not hide 'Bekleyen analiz yok' when I click
              'Arşivlenmiş'"). */}
          {!analyses.some(isNodeVisible) ? (
            <li>
              <p className="p-3 text-sm text-muted">
                {analyses.length === 0
                  ? t('analysis.inbox.emptyQueue')
                  : t('analysis.inbox.noPendingMatches')}
              </p>
            </li>
          ) : null}

          {/* ARŞİV bölümü (Rev. 3 §15) — HER ZAMAN render edilir, hiç istenmemiş/yükleniyor/
              hatalı/boş/dolu FARK ETMEZ. Bandın etiketi, büyük/küçük harfi, ağırlığı, glifi ve
              konumu HİÇBİR tıklamada DEĞİŞMEZ (owner raporunun ikinci cümlesi, §15.3) — chevron
              dışında görünür hiçbir şey kıpırdamaz. */}
          <li>
            <h2 className="flex">
              <button
                type="button"
                id={archivedToggleId}
                aria-expanded={archivedOpen}
                aria-controls={archivedOpen ? archivedPanelId : undefined}
                onClick={toggleArchived}
                className="flex h-14 w-full items-center gap-1.5  border-t border-border  px-3 text-left text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring"
              >
                <ChevronRight
                  className={cn(
                    'h-3.5 w-3.5 shrink-0 transition-transform duration-150',
                    archivedOpen && 'rotate-90',
                  )}
                  aria-hidden="true"
                />
                <Archive className="h-3.5 w-3.5 shrink-0 text-muted" aria-hidden="true" />
                <span className="min-w-0 flex-1 truncate text-xs font-semibold">
                  {t('analysis.inbox.archivedSectionLabel')}
                </span>
                {!archivedOpen &&
                archivedRequested &&
                !archivedLoading &&
                archivedError === null ? (
                  <span className="shrink-0 text-xs tnum text-muted">
                    {t('analysis.inbox.archivedCount', { count: archivedVisible.length })}
                  </span>
                ) : null}
              </button>
            </h2>

            {archivedOpen ? (
              // biome-ignore lint/a11y/useSemanticElements: role="group" kasıtlı — 1. seviye paneliyle AYNI gerekçe
              <div id={archivedPanelId} role="group" aria-labelledby={archivedToggleId}>
                {archivedLoading ? (
                  <div className="flex items-center gap-2 px-3 py-2 text-sm text-muted">
                    <Spinner className="h-4 w-4" />
                    {t('common.loading')}
                  </div>
                ) : archivedError ? (
                  <div className="flex flex-col items-start gap-2 px-3 py-2">
                    <p className="text-xs text-danger">
                      {resolveApiErrorMessage(archivedError, t)}
                    </p>
                    <Button variant="ghost" size="sm" onClick={onRetryArchived}>
                      {t('state.error.retry')}
                    </Button>
                  </div>
                ) : archivedVisible.length === 0 ? (
                  <p className="p-3 text-sm text-muted">
                    {archivedAnalyses.length === 0
                      ? t('analysis.inbox.archivedEmpty')
                      : t('analysis.inbox.noArchivedMatches')}
                  </p>
                ) : (
                  <ul>{archivedAnalyses.map((entry) => renderAnalysisNode(entry, true))}</ul>
                )}
              </div>
            ) : null}
          </li>
        </ul>
      </nav>
    </div>
  );
}
